import React, {useState} from 'react'
import {gql, useMutation,useQuery} from "@apollo/client";
import Chart from 'chart.js';
import '../App.css';


const GET_SALIDA = gql `
query getSalidas{
  getSalidas{
    _id
   fecha
   concepto
   cantidad
  } 
}`



const ELIMINAR_SALIDA = gql`mutation eliminarSalida($id:ID!){
eliminarSalida(_id:$id)
}`


const ACTUALIZAR_SALIDA = gql`
  mutation editarSalida($id: ID!, $nuevaCantidad: Int) {
    editarSalida(_id: $id, cantidad: $nuevaCantidad) {
      _id
      fecha
      concepto
      cantidad
    }
  }
`;


function GetSalida() {
  const [filtroNumero, setFiltroNumero] = useState("");
 
  const [editingSalida, setEditingSalida] = useState(null);
  const [nuevaCantidad, setNuevaCantidad] = useState(0);
  const [editarSalida] = useMutation(ACTUALIZAR_SALIDA)
   
    const {loading, error, data} = useQuery(GET_SALIDA);
    const [eliminarSalida] = useMutation(ELIMINAR_SALIDA, {
      refetchQueries: [{ query: GET_SALIDA }]
    });

  
   
 
  
      
    if(loading) return <p>Esperando resultados...</p>;
        if(error) return <p>Error</p>;

        
        
        const totalSalidas=data.getSalidas.reduce((acumulador, entrada) => acumulador + entrada.cantidad, 0)
        const reversedData = data.getSalidas.slice().reverse();

        const comienzaConNumero = (numero, salidaCantidad) => {
          return salidaCantidad.toString().startsWith(numero);
        };
/*
        const dates = reversedData.map(salida => salida.fecha);
        const amounts = reversedData.map(salida => salida.cantidad);
    
        const ctx = document.getElementById('salidaChart');
    new Chart(ctx, {
      type: 'bar',
      data: {
        labels: dates,
        datasets: [{
          label: 'Cantidad de Salidas',
          data: amounts,
          backgroundColor: 'rgba(75, 192, 192, 0.2)',
          borderColor: 'rgba(75, 192, 192, 1)',
          borderWidth: 1
        }]
      },
      options: {
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    });
 */

    return (
      <div>

<div className="row">
        {/* Gráfico de Salidas */}
        <div className="col-md-12">
          <canvas id="salidaChart" width="400" height="200"></canvas>
        </div>
      </div>

        <div className="card card-total">
          <h1>Total egresos</h1>
          <h1>{totalSalidas}</h1>
        </div>
        <div className="container">
          <form>
            <label htmlFor="filtroNumero">Filtrar por Cantidad:</label>
            <input
              type="number"
              id="filtroNumero"
              value={filtroNumero}
              onChange={(e) => setFiltroNumero(e.target.value)}
            />
            <button type="submit">Aplicar Filtro</button>
          </form>
          
          
          <div className="row">
            {reversedData.map((salida) => {
              if (filtroNumero === "" || comienzaConNumero(filtroNumero, salida.cantidad))  {

                return (
                  <div className="card  card-salida col-xs-12 col-xl-4 col-sm-6" key={salida._id}>
                    <div className="card-body">
                      <h3 className="card-title">{salida.concepto}</h3>
                      <h4 className="card-text">{salida.fecha}</h4>
                      <h4 className="card-text">{salida.cantidad}</h4>
                      <button
                        className="btn btn-danger"
                        onClick={() => {
                          eliminarSalida({ variables: { id: salida._id } });
                        }}
                        disabled={loading}
                      >
                        eliminar
                      </button>
                      {editingSalida === salida._id ? (
                        <>
                          <input
                            type="number"
                            value={nuevaCantidad}
                            onChange={(e) => setNuevaCantidad(parseInt(e.target.value))}
                          />
                          <button
                            className="btn btn-primary"
                            onClick={() => {
                              editarSalida({
                                variables: { id: salida._id, nuevaCantidad },
                              });
                              setEditingSalida(null);
                              setNuevaCantidad(0);
                            }}
                          >
                            Guardar
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            className="btn btn-primary"
                            onClick={() => {
                              setEditingSalida(salida._id);
                              setNuevaCantidad(salida.cantidad);
                            }}
                          >
                            Editar
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                );
              } else {
                return null;
              }
            })}
          </div>
        </div>
      </div>
    );
}

export default GetSalida